<template>
  <ReviewMenuSimpleCount link_to='/live-grade-reviews/' title='Grade reviews' />
</template>

<script>
import ReviewMenuSimpleCount from '@/components/review/ReviewMenuSimpleCount'
import Store from './LiveGradeReviews.store'

export default {
  components: { ReviewMenuSimpleCount },
  created() {
    this.$store.loadStoreModule({ module: Store })
  },
}
</script>